module.exports = __webpack_public_path__ + "556252e257cb22fcd3c027bb59aa4147.svg";